export const pwtoken = () => {
    var _a;
    return (_a = ((document.cookie.match(/(^|; )Paywall-Token=([^;]+)/) || [])[2])) !== null && _a !== void 0 ? _a : null;
};
